import { Fade } from '@mui/material';
import React, { ReactElement } from 'react';

interface IFadeComponentsProps {
  children: ReactElement;
}

const FadeComponent = ({ children }: IFadeComponentsProps) => {
  return (
    <Fade in timeout={500}>
      {children}
    </Fade>
  );
};

export default FadeComponent;
